import PropTypes from 'prop-types';
import * as type from '../actions/types';

const initialState = {
  fetching: false,
  data: {
    // restId: null,
    // offPeakOptimized: null,
  },
  error: false,
  errorMessage: '',
  success: false,
};

// Export prop types for easy import in components that use this data
export const potentialDineInRevenuePropTypes = PropTypes.shape({
  restId: PropTypes.string,
  offPeakOptimized: PropTypes.number,
  lowerOffersOptimized: PropTypes.number,
  maxRevenue: PropTypes.shape({
    type: PropTypes.string,
    amount: PropTypes.number,
    customersLower: PropTypes.number,
    customersUpper: PropTypes.number,
  }), // Store the type that has the highest and its value
});

export const potentialDineInRevenuesPropTypes = PropTypes.shape({
  data: potentialDineInRevenuePropTypes,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  fetching: PropTypes.bool,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_POTENTIAL_DINE_IN_REVENUES_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        success: false,
        errorMessage: '',
      };
    case type.FETCH_POTENTIAL_DINE_IN_REVENUES_SUCCESS:
      // Store which deal had the highest potential revenue
      let maxRevenue = {
        type: 'offPeak',
        amount: action.payload?.offPeakOptimized,
        customersLower: action.payload?.offPeakCustomersLower,
        customersUpper: action.payload?.offPeakCustomersUpper,
      };

      if (action.payload?.lowerOffersOptimized > action.payload?.offPeakOptimized) {
        maxRevenue = {
          type: 'lowerOffers',
          amount: action.payload?.lowerOffersOptimized,
          customersLower: action.payload?.lowerOffersCustomersLower,
          customersUpper: action.payload?.lowerOffersCustomersUpper,
        };
      }

      return {
        ...state,
        fetching: false,
        data: {
          ...action.payload,
          maxRevenue,
        },
        error: false,
        errorMessage: '',
        success: true,
      };
    case type.FETCH_POTENTIAL_DINE_IN_REVENUES_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };

    case type.CLEAR_POTENTIAL_DINE_IN_REVENUES:
      return {
        ...state,
        data: {},
        error: false,
        errorMessage: '',
        fetching: false,
        success: false,
      };
    default:
      return state;
  }
};
